import React from "react";
import { BookStore } from "../../flux";
import { NotebookDialog } from "../../components";

import PrintNotes from "./print-notes";
import { createRoot } from "react-dom/client";

const onSubmit = function(selectedHighlights) {
  const book = BookStore.get(this.props.isbn);
  selectedHighlights = selectedHighlights.mine.concat(
    selectedHighlights.theirs
  );
  if (this.state.randomOrder) {
    selectedHighlights = Fraction.Helpers.shuffleArray(selectedHighlights);
  } else {
    selectedHighlights = selectedHighlights.sort(this._compareBookOrder);
  }
  this.setState(
    {
      setupMode: false,
      selectedHighlights: selectedHighlights,
      highlightIndex: 0
    },
    function() {
      if (!window.location.origin) {
        window.location.origin =
          window.location.protocol +
          "//" +
          window.location.hostname +
          (window.location.port ? ":" + window.location.port : "");
      }
      var win = window.open(location.origin);
      setTimeout(
        function() {
          win.document.title =
            i18n.t("reader.panels.notebook").capitalizeFirst() +
            ": " +
            book.title;
          win.document.body.style.overflow = "auto";
          win.document.documentElement.style.background = "white";
          createRoot(win.document.body).render(
            <PrintNotes
              notes={this.state.selectedHighlights}
              isbn={this.props.isbn}
            />
          );
          setTimeout(() => win.print(), 0);
        }.bind(this),
        1000
      );
    }.bind(this)
  );
  Fraction.Reporter.gaEvent("/print-notebook-submitted");
};

const _printNotesDialog = isbn => {
  const title = i18n.t("print-notes.print-notebook");
  Fraction.Reporter.gaEvent("/print-notebook-modal-opened");
  return {
    title,
    isbn,
    menuId: title,
    closeCallback: function() {},
    buttons: [],
    intersitial: true,
    definingClass: "notebook-modal",
    modalContainerHeader: true,
    width: 570,
    height: 470,
    content: <NotebookDialog isbn={isbn} title={title} onSubmit={onSubmit} />
  };
};

const setupPrintNotes = isbn => {
  const setupDialog = _printNotesDialog(isbn);
  if (Fraction.Helpers.isSmallScreen()) {
    setupDialog.intersitial = true;
    setupDialog.definingClass =
      setupDialog.definingClass + " mobile-notebook-dialog";
  }
  Fraction.Helpers.showVSTModal(
    setupDialog,
    document.getElementById("launch-print-notebook-button")
  );
};

export default setupPrintNotes;
